import Text from "../../../../../../packages/design-system/src/Text";
import Alert from "../../../../../../packages/design-system/src/Alert";
import * as React from 'react';
export default {
  Text,
  Alert,
  React
};